<script setup>
defineProps({
  image: {
    type: String,
    required: true,
  },

  icon: {
    type: String,
    required: true,
  },

  title: {
    type: String,
    required: true,
  },
});

const { tp } = useTypograf();
</script>

<template>
  <div class="card-offer">
    <div class="card-offer__media">
      <img :src="image" alt="" class="card-offer__image" />

      <img :src="icon" alt="" loading="lazy" class="card-offer__icon" />
    </div>

    <h3 class="card-offer__title">
      <span class="card-offer__font card-offer__font--title">
        {{ tp(title) }}
      </span>
    </h3>
  </div>
</template>

<style scoped lang="scss">
.card-offer {
  &__media {
    position: relative;
    height: em(397);

    @include media-breakpoint-mobile {
      height: em(249);
    }
  }

  &__image {
    object-fit: cover;
    width: 100%;
    height: 100%;
  }

  &__icon {
    position: absolute;
    inset-inline-start: em(68);
    bottom: em(36);
    border-radius: em(20);
    background-color: rgba($color-second-1, 0.25);

    @include box(em(79));

    @include media-breakpoint-mobile {
      inset-inline-start: em(26);
      bottom: em(23);
      border-radius: em(12);

      @include box(em(46));
    }
  }

  &__title {
    margin-top: em(50);

    @include media-breakpoint-desktop {
      padding-inline-start: em(68);
    }

    @include media-breakpoint-mobile {
      display: none;
    }
  }

  &__font {
    &--title {
      font-size: em(32);
      line-height: em(39, 32);

      @include media-breakpoint-mobile {
        font-size: em(16);
      }
    }
  }
}
</style>
